// Crop color mapping utility
export const cropColors = [
  { name: "Corn", color: "#FFFF00" },
  { name: "Soybeans", color: "#00FF00" },
  { name: "Soybean", color: "#00FF00" },
  { name: "Wheat", color: "#FFFFFF" },
  { name: "Cotton", color: "#FF00FF" },
  { name: "Rice", color: "#00FFFF" },
  { name: "Sorghum", color: "#FFA500" },
  { name: "Barley", color: "#8B4513" },
  { name: "Oats", color: "#C8C8C8" },
  { name: "Alfalfa", color: "#006400" },
  { name: "Other Hay", color: "#00FF80" },
  { name: "Peanuts", color: "#FFA500" },
  { name: "Sunflower", color: "#FFD700" },
  { name: "Canola", color: "#FFFF80" },
  { name: "Potatoes", color: "#8B0000" },
  { name: "Sugar Beets", color: "#FF69B4" },
  { name: "Dry Beans", color: "#8B4513" },
  { name: "Peas", color: "#FF8C00" },
  { name: "Lentils", color: "#DAA520" },
  { name: "Chickpeas", color: "#F4A460" },
  { name: "Mint", color: "#98FB98" },
  { name: "Onions", color: "#FFE4E1" },
  { name: "Cucumbers", color: "#90EE90" },
  { name: "Tomatoes", color: "#FF6347" },
  { name: "Sweet Corn", color: "#FFD700" },
  { name: "Popcorn", color: "#F0E68C" },
  { name: "Sweet Potatoes", color: "#CD853F" },
  { name: "Misc Vegs & Fruits", color: "#FF69B4" },
  { name: "Watermelons", color: "#FF1493" },
  { name: "Cantaloupes", color: "#FFA07A" },
  { name: "Pumpkins", color: "#FF8C00" },
  { name: "Squash", color: "#FF7F50" },
  { name: "Dbl Crop WinWht/Soybeans", color: "#F0E68C" },
  { name: "Dbl Crop Oats/Corn", color: "#DDA0DD" },
  { name: "Dbl Crop Barley/Soybeans", color: "#98FB98" },
  { name: "Dbl Crop WinWht/Corn", color: "#F5DEB3" },
  { name: "Dbl Crop Barley/Corn", color: "#E6E6FA" },
  { name: "Dbl Crop Soybeans/Cotton", color: "#FFB6C1" },
  { name: "Dbl Crop Soybeans/Oats", color: "#87CEEB" },
  { name: "Dbl Crop Corn/Soybeans", color: "#DDA0DD" },
  { name: "Blueberries", color: "#4169E1" },
  { name: "Cabbage", color: "#32CD32" },
  { name: "Cauliflower", color: "#F0F8FF" },
  { name: "Celery", color: "#90EE90" },
  { name: "Radishes", color: "#FF69B4" },
  { name: "Turnips", color: "#F0E68C" },
  { name: "Eggplants", color: "#9932CC" },
  { name: "Gourds", color: "#FF8C00" },
  { name: "Cranberries", color: "#DC143C" },
  { name: "Asparagus", color: "#90EE90" },
  { name: "Carrots", color: "#FFA500" },
  { name: "Garlic", color: "#F5F5DC" },
  { name: "Honeydew Melons", color: "#F0FFF0" },
  { name: "Broccoli", color: "#228B22" },
  { name: "Peppers", color: "#FF4500" },
  { name: "Pomegranates", color: "#DC143C" },
  { name: "Nectarines", color: "#FFB6C1" },
  { name: "Greens", color: "#228B22" },
  { name: "Plums", color: "#DDA0DD" },
  { name: "Strawberries", color: "#FF69B4" },
  { name: "Sod/Grass Seed", color: "#00CED1" },
  { name: "Switchgrass", color: "#228B22" },
  { name: "Fallow/Idle Cropland", color: "#F5F5DC" },
  { name: "Forest", color: "#228B22" },
  { name: "Shrubland", color: "#8B4513" },
  { name: "Barren", color: "#D2B48C" },
  { name: "Cherries", color: "#DC143C" },
  { name: "Peaches", color: "#FFB6C1" },
  { name: "Apples", color: "#FF6347" },
  { name: "Grapes", color: "#9932CC" },
  { name: "Christmas Trees", color: "#228B22" },
  { name: "Other Tree Crops", color: "#8B4513" },
  { name: "Citrus", color: "#FFA500" },
  { name: "Pecans", color: "#8B4513" },
  { name: "Almonds", color: "#F5DEB3" },
  { name: "Walnuts", color: "#8B4513" },
  { name: "Pears", color: "#90EE90" },
  { name: "Pistachios", color: "#90EE90" },
  { name: "Triticale", color: "#F5DEB3" },
  { name: "Developed/Open Space", color: "#C0C0C0" },
  { name: "Developed/Low Intensity", color: "#808080" },
  { name: "Developed/Medium Intensity", color: "#FF0000" },
  { name: "Developed/High Intensity", color: "#800000" },
  { name: "Open Water", color: "#0000FF" },
  { name: "Perennial Ice/Snow", color: "#FFFFFF" },
  { name: "Deciduous Forest", color: "#228B22" },
  { name: "Evergreen Forest", color: "#006400" },
  { name: "Mixed Forest", color: "#6B8E23" },
  { name: "Grassland/Pasture", color: "#7CFC00" },
  { name: "Woody Wetlands", color: "#00CED1" },
  { name: "Herbaceous Wetlands", color: "#ADD8E6" }
];

export const getCropColor = (cropName: string): string => {
  const crop = cropColors.find(c => c.name.toLowerCase() === cropName.toLowerCase());
  return crop ? crop.color : '#FF9800'; // Default orange for unknown crops
};

export const getCropColorWithOpacity = (cropName: string, opacity: number = 0.6): string => {
  const color = getCropColor(cropName);
  
  // Convert hex to rgba
  const hex = color.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
